export default "__VITE_ASSET__Ip35e_KJ__"